import { useEffect, useState } from "react";
import { Camera, Sparkles, MessageCircle, Check } from "lucide-react";

const STEPS = ["Foto de tu menú", "Menú digital con IA", "Pedido por WhatsApp"];

const MenuPhoto = () => (
  <div className="h-full flex flex-col">
    <p className="text-xs font-semibold text-gray-500 mb-2 flex items-center gap-1"><Camera className="w-3.5 h-3.5" /> Tomando foto…</p>
    <div className="flex-1 rounded-2xl bg-[#F5E9DA] border-4 border-[#E8D5BE] p-4 relative overflow-hidden">
      <p className="font-heading font-bold text-center text-[#7A4A1E] text-sm mb-3 tracking-wide">TAQUERÍA DOÑA CHELO</p>
      {["Tacos al pastor", "Gringa de bistec", "Quesadilla", "Agua de horchata", "Refresco"].map((n, i) => (
        <div key={n} className="flex justify-between text-[11px] text-[#5C3B1A] py-1.5 border-b border-dashed border-[#D9BF9C]">
          <span>{n}</span><span>${[25, 65, 45, 30, 28][i]}</span>
        </div>
      ))}
      <div className="absolute inset-x-0 top-0 h-1 bg-brand-orange animate-[scan_2.4s_linear_infinite]" />
    </div>
    <div className="mt-3 flex items-center gap-2 text-xs text-brand-orange font-semibold"><Sparkles className="w-4 h-4" /> La IA la está leyendo…</div>
  </div>
);

const DigitalMenu = () => (
  <div className="h-full flex flex-col">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-8 h-8 rounded-lg bg-brand-orange grid place-items-center text-white text-xs font-bold">DC</div>
      <div><p className="text-xs font-bold leading-none">Doña Chelo</p><p className="text-[10px] text-brand-green font-semibold">Abierto · Pedidos por WhatsApp</p></div>
    </div>
    {[["Tacos al pastor", 25, "🌮"], ["Gringa de bistec", 65, "🫓"], ["Quesadilla", 45, "🧀"], ["Agua de horchata", 30, "🥤"]].map(([n, p, e], i) => (
      <div key={n} className="flex items-center gap-3 p-2 rounded-xl bg-brand-cream mb-2" style={{ animation: `pop 0.4s ease ${i * 0.15}s both` }}>
        <span className="text-xl">{e}</span>
        <div className="flex-1"><p className="text-xs font-semibold">{n}</p><p className="text-[10px] text-gray-500">MXN ${p}</p></div>
        <span className="w-6 h-6 rounded-full bg-brand-orange text-white grid place-items-center text-sm font-bold">+</span>
      </div>
    ))}
    <button className="mt-auto w-full rounded-xl bg-brand-wa text-white text-xs font-bold py-2.5">Pedir por WhatsApp · $185</button>
  </div>
);

const WaChat = () => (
  <div className="h-full flex flex-col bg-[#EFE7DD] -m-4 mt-[-44px] pt-[44px] p-4 rounded-[30px]">
    <div className="flex items-center gap-2 bg-[#075E54] text-white -mx-4 -mt-1 px-4 py-2">
      <div className="w-7 h-7 rounded-full bg-brand-orange grid place-items-center text-[10px] font-bold">DC</div>
      <div><p className="text-xs font-bold leading-none">Doña Chelo</p><p className="text-[10px] opacity-80">en línea</p></div>
    </div>
    <div className="flex-1 flex flex-col gap-2 pt-3 text-[11px]">
      <div className="self-end bg-[#DCF8C6] rounded-xl rounded-tr-sm px-3 py-2 max-w-[85%] shadow-sm">Hola 👋 quiero 4 tacos al pastor y 1 gringa</div>
      <div className="self-start bg-white rounded-xl rounded-tl-sm px-3 py-2 max-w-[85%] shadow-sm">¡Claro! Son <b>$165</b>. ¿Para recoger o a domicilio?</div>
      <div className="self-end bg-[#DCF8C6] rounded-xl rounded-tr-sm px-3 py-2 max-w-[85%] shadow-sm">A domicilio, pago en efectivo</div>
      <div className="self-start bg-white rounded-xl rounded-tl-sm px-3 py-2 max-w-[85%] shadow-sm flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-brand-green" /> Pedido #48 confirmado · 25 min</div>
    </div>
    <div className="mt-2 rounded-xl bg-white/90 p-2 text-center text-[11px] font-bold text-brand-green">$165 → 100% a tu caja · $0 comisión</div>
  </div>
);

export const PhoneMockup = () => {
  const [step, setStep] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setStep((s) => (s + 1) % 3), 3200);
    return () => clearInterval(id);
  }, []);
  const views = [<MenuPhoto key="a" />, <DigitalMenu key="b" />, <WaChat key="c" />];
  return (
    <div className="relative mx-auto w-[280px]" data-testid="phone-mockup">
      <div className="phone">
        <div className="phone-screen">
          {views.map((v, i) => (
            <div key={i} className={`phone-view ${i === step ? "active" : i < step ? "done" : ""}`}>{v}</div>
          ))}
        </div>
      </div>
      <div className="float-card -left-10 top-24 hidden sm:block" style={{ animationDelay: "0.5s" }}>
        <p className="text-[10px] text-gray-500">Pedido #48</p><p className="font-bold text-brand-green">+$165 MXN</p>
      </div>
      <div className="float-card -right-8 bottom-28 hidden sm:block" style={{ animationDelay: "1.6s" }}>
        <p className="text-[10px] text-gray-500">Comisión</p><p className="font-bold text-brand-orange">$0.00</p>
      </div>
      <div className="mt-5 flex items-center justify-center gap-2" aria-hidden="true">
        {STEPS.map((s, i) => (
          <button key={s} onClick={() => setStep(i)} className={`h-2 rounded-full transition-all ${i === step ? "w-8 bg-brand-orange" : "w-2 bg-orange-200"}`} aria-label={s} />
        ))}
      </div>
      <p className="mt-2 text-center text-sm font-semibold text-gray-600" data-testid="phone-step-label">{step + 1}. {STEPS[step]}</p>
      <style>{`@keyframes scan{0%{top:0}100%{top:100%}}@keyframes pop{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}`}</style>
    </div>
  );
};

export default PhoneMockup;
